import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SurchargeRelations } from '../types';

import { schema } from '../utils/schema';

import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';

import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import useSave from '../hooks/useSave';
import { CostCentersSelect } from './CostCentersSelect';
import { SurchargesSelect } from './SurchargesSelect';

interface Props {
  handleClose: () => void;
  data: SurchargeRelations | null;
}

const SurchargeRelationsForm = ({ handleClose, data }: Props) => {
  const { t } = useTranslation('common');
  const { mutate } = useSave(!!data, handleClose);
  const methods = useForm({
    defaultValues: data ? schema.cast(data) : undefined,
    resolver: yupResolver(schema)
  });

  const onSubmit = (data) => {
    mutate(data);
  };

  return (
    <>
      <MultiStepForm methods={methods} onSubmit={onSubmit}>
        <MultiStepForm.Section
          title={t('surchargeRelations.formSectionLabels.basis')}
          validateFields={[
            'brEmployerLinkClientId',
            'employerBrDynId',
            'surchargeId'
          ]}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CostCentersSelect
                name="clientBrDynId"
                label={t('surchargeRelations.employer')}
              />
            </Grid>
            <Grid item xs={12}>
              <CostCentersSelect
                name="employerBrDynId"
                label={t('surchargeRelations.client')}
              />
            </Grid>
            <Grid item xs={12}>
              <SurchargesSelect />
            </Grid>
          </Grid>
        </MultiStepForm.Section>
        <MultiStepForm.Actions>
          <Box display="flex" ml="auto">
            <LoadingButton
              loading={false}
              type="submit"
              variant="contained"
              autoFocus
              color="dark"
            >
              {t('save')}
            </LoadingButton>
          </Box>
        </MultiStepForm.Actions>
      </MultiStepForm>
    </>
  );
};

export default SurchargeRelationsForm;
